export enum AutomotiveAftermarketTileType {
  Load = 'load',
  TransportOrder = 'transportOrder',
  DeliveryNote = 'deliveryNote',
  HandlingUnit = 'handlingUnit',
}
export enum AutomotiveAftermarketRangeDate {
  StatusDate = 'statusDate',
}
